import React from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  Container,
  FormikWrapper,
  Pagination,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Node,
  ViewFilters,
  useViewFilterQuery,
} from '@uncinc/react-drupal-core';
import type {
  ImmutableEntity,
  Pager,
} from '@uncinc/react-drupal-core/types';

import { NodeArticle } from '../../../types/uncinc_profile/nodes';
import { ViewFilter } from '../../../components';
import {
  Filter,
  FilterProps,
} from '../../../components/ViewFilter';

interface ArticlesFilteredProps {
  entities: Immutable.List<ImmutableEntity<NodeArticle>>;
  pager: Immutable.List<ImmutableEntity<Pager>>;
  filters: Filter[];
}

const ArticlesFiltered: React.FC<ArticlesFilteredProps> = ({ entities, pager, filters }) => {
  const totalPages = Number(pager.getIn(['total_pages'])) || 0;
  const { page, setCurrentPage, setFilters } = useViewFilterQuery();
  const currentPage: number = Number(page) + 1;
  const { t } = useTranslation();

  return (
    <FormikWrapper>
      <Container>
        <ViewFilters
          viewId="articles_filtered"
          display="default"
          onResetFilter={() => { }}
          onFilterUpdate={(field: any, value: any) => {
            setFilters({
              ...filters,
              [field]: value,
            });
          }}
          onRender={(data: FilterProps) => (
            <ViewFilter {...data} filters={filters} />
          )}
        />

        {entities.size === 0 && (
          <div>
            <h3>{t('pages.search.result_empty_title')}</h3>
            <p>{t('pages.search.result_empty_body')}</p>
          </div>
        )}

        <div className="row">
          {
            entities.map((entity) => {
              const id = entity.getIn(['nid', 0, 'value']);
              const uuid = entity.getIn(['uuid', 0, 'value']);
              const langcode = entity.getIn(['langcode', 0, 'value']);
              const key = `${uuid}:${langcode}`;

              return (
                <Node
                  key={key}
                  id={id}
                  entity={entity}
                  viewMode="teaser"
                  classes="col-sm-6 col-md-4"
                />
              );
            })
          }
        </div>

        <div className="ViewArticlesFiltered__pager">
          <Pagination
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageRangeDisplayed={totalPages > 6 ? 2 : 5}
            marginPagesDisplayed={totalPages > 6 ? 1 : 0}
            selectPage={setCurrentPage}
            previousLabel={<div className="Pagination__previous"><i className="icon-before icon-arrow icon-variant-1" /><span>{t('general.next')}</span></div>}
            nextLabel={<div className="Pagination__next"><span>{t('general.previous')}</span><i className="icon-after icon-arrow icon-variant-1" /></div>}
            controlled
          />
        </div>
      </Container>
    </FormikWrapper>
  );
};

export default ArticlesFiltered;
